import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDeviceData } from '../../../entity/interface/iDevices';
import { IDeviceRepository } from '../../repositories/interfaces/iDeviceRepository';

export interface IGetDevicesUseCase {
    execute(
        username: string,
        apiKey: string,
        token: string,
        identityToken: string,
        uid?: string | undefined,
        guid?: string | undefined
    ): Promise<IDeviceData[]>;
}

export class GetDeviceUseCase implements IGetDevicesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getDeviceRepository(): IDeviceRepository {
        return container.resolve<IDeviceRepository>(DI.REPOSITORIES.IDeviceRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        apiKey: string,
        token: string,
        identityToken: string,
        uid?: string | undefined,
        guid?: string | undefined
    ): Promise<IDeviceData[] | any> {
        const response = await this.getDeviceRepository.getDevices(username, apiKey, token, identityToken, uid, guid);
        return response.data || [];
    }
}
